import React from 'react';
import AutocompleteInput from './AutocompleteInput';

function UserDataSection({formData, updateFormData, usersWithGroups}) {
  const handleChange = (field, value) => {
    console.log(`UserDataSection - handleChange actualizando ${field} con:`, value);
    updateFormData({[field]: value});
  };

  const handleNameChange = (name) => {
    console.log('UserDataSection - handleNameChange llamado con:', name);
    // Actualizar el campo de nombre
    updateFormData({name: name});
  };

  const handleUserSelect = (selectedUser) => {
    console.log('UserDataSection - handleUserSelect llamado con:', selectedUser);
    
    // Al seleccionar un usuario, actualizar todos los datos relacionados
    if (selectedUser && selectedUser.name) {
      const updatedData = {
        name: selectedUser.name,
        interestedName: selectedUser.name,
        group: selectedUser.group || '',
        employeeNumber: selectedUser.employeeNumber || '',
        location: selectedUser.location || '',
        lockerNumber: selectedUser.lockerNumber || ''
      };
      console.log('UserDataSection - Actualizando datos con:', updatedData);
      updateFormData(updatedData);
    }
  };

  const locationOptions = [
    'V1', 'V2', 'V3', 'V4', 'V5', 'V6', 'V7', 'V8', 'V9', 'V10', 
    'V11', 'V12', 'V13', 'V14', 'V18', 'NAVE 9', 'NAVE 11'
  ];

  return (
    <div className="space-y-3 sm:space-y-4">
      <div className="bg-yellow-100 p-2 sm:p-3 rounded">
        <h3 className="text-sm sm:text-lg font-semibold text-center">DATOS DEL USUARIO</h3>
      </div>
      
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          NOMBRE:
        </label>
        <AutocompleteInput 
          value={formData.name} 
          onChange={handleNameChange} 
          onSelectUser={handleUserSelect} 
          placeholder="Introduce el nombre" 
          className="w-full" 
          usersWithGroups={usersWithGroups} 
        />
      </div>
      
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Nº EMPLEADO:
        </label>
        <input
          type="text"
          value={formData.employeeNumber || ''}
          onChange={(e) => handleChange('employeeNumber', e.target.value)}
          className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          placeholder="Introduce el número de empleado"
        />
        {formData.employeeNumber && (
          <p className="mt-1 text-xs text-green-600">✓ Nº de empleado registrado</p>
        )}
      </div>
      
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          GRUPO:
        </label>
        <input
          type="text"
          value={formData.group || ''}
          onChange={(e) => handleChange('group', e.target.value)}
          className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          placeholder="Introduce el grupo"
        />
        {formData.group && (
          <p className="mt-1 text-xs text-green-600">✓ Grupo autocompletado desde la selección</p>
        )}
      </div>
      
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          UBICACIÓN:
        </label>
        <select
          value={formData.location || ''}
          onChange={(e) => handleChange('location', e.target.value)}
          className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
        >
          <option value="">Seleccionar ubicación</option>
          {locationOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          NÚMERO DE TAQUILLA:
        </label>
        <input
          type="text"
          value={formData.lockerNumber || ''}
          onChange={(e) => handleChange('lockerNumber', e.target.value)}
          className="w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          placeholder="Introduce el número"
        />
      </div>
    </div>
  );
}

export default UserDataSection;